module.exports = __webpack_public_path__ + "static/integra-blog-47af274b61018bf09f1f5e95549cf2df.png";